export default "__VITE_ASSET__DNQjpUZz__"